<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.791"
    height="18.189"
    viewBox="0 0 14.791 18.189"
    aria-hidden="true"
  >
    <g
      id="streamline-icon-stopwatch_200x200"
      data-name="streamline-icon-stopwatch@200x200"
      transform="translate(-24.4 -5.65)"
    >
      <path
        id="Path_44620"
        data-name="Path 44620"
        d="M25,50.546a6.8,6.8,0,1,0,6.8-6.8A6.8,6.8,0,0,0,25,50.546Z"
        transform="translate(0 -34.102)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44621"
        data-name="Path 44621"
        d="M150,48.291l1.416-1.416"
        transform="translate(-113.674 -36.944)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44622"
        data-name="Path 44622"
        d="M162.5,43.75l.566.566"
        transform="translate(-125.041 -34.102)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44623"
        data-name="Path 44623"
        d="M100,9.648V6.25"
        transform="translate(-68.204 0)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44624"
        data-name="Path 44624"
        d="M84.648,6.25h-3.4"
        transform="translate(-51.153)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44625"
        data-name="Path 44625"
        d="M71.581,93.543,68.75,90.408"
        transform="translate(-39.786 -76.533)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconSalesTimer',
};
</script>
<style lang="scss" scoped>
.cls-1 {
  fill: none;
  stroke: #fa0;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
